import { render, staticRenderFns } from "./AbnormalAttendanceApproval.vue?vue&type=template&id=9a4f663a&scoped=true&"
import script from "./AbnormalAttendanceApproval.vue?vue&type=script&setup=true&lang=js&"
export * from "./AbnormalAttendanceApproval.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a4f663a",
  null
  
)

export default component.exports